const ko = {
    'gui.extension.zumiAIB.name': 'Zumi AI (블루투스)',
    'gui.extension.zumiAIB.description': '블루투스로 주미 AI를 연결',
    'gui.extension.zumiAIB.connectingMessage': '연결 중...',

    'gui.extension.zumiAIS.name': 'Zumi AI (동글)',
    'gui.extension.zumiAIS.description': '동글로 주미 AI를 연결',
    'gui.extension.zumiAIS.connectingMessage': '연결 중...',

    'gui.extension.smartLink.name': '스마트 링크',
    'gui.extension.smartLink.description': '스마트 링크를 사용하여 메시지를 주고받으세요.',
    'gui.extension.smartLink.connectingMessage': '연결 중...',

    'gui.gui.connectionPromptQuestion': '블루투스로 연결하시나요, 동글로 연결하시나요?',
    'gui.gui.connectionPromptBluetooth': '블루투스',
    'gui.gui.connectionPromptDongle': '동글',
    'gui.gui.connectionPromptCancel': '취소',


    'gui.lessonPanel.allLessons': '전체 레슨 목록',
    'gui.lessonPanel.prevStep': '< 이전',
    'gui.lessonPanel.nextStep': '다음 >',
    'gui.lessonPanel.understand': '이해했어요',
    'gui.lessonPanel.lessonDone': '완료',
    'gui.lessonPanel.retry': '다시 풀기',

    // 메뉴바
    'gui.sharedMessages.loadFromComputerTitle': '컴퓨터에서 불러오기',

    // 레슨 메뉴 관련 추가
    'gui.menuBar.lesson': '레슨',
    'gui.menuBar.lessonHide': '레슨 숨기기',
    'gui.menuBar.lessonShow': '레슨 보이기',


    'gui.gui.confirmResetProgress': '모든 레슨의 완료 체크를 초기화하시겠습니까?',
    'gui.gui.confirmLoadExample': '코드를 불러오면 현재 작업 중인 내용이 사라집니다. 진행할까요?',
    'gui.gui.loadExampleFailed': '예시 코드를 불러오지 못했습니다.',


    'gui.gui.confirmResetProgress': '모든 레슨의 완료 체크를 초기화하시겠습니까?',
    'gui.menuBar.lessonResetProgress': '레슨 진행 상태 초기화'






};

export default {ko};